import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import TextSwapper from "@Components/TextSwapper/TextSwapper";
import PostBookLoaderIcon from "@Icons/Flight/PostBookLoaderIcon/PostBookLoaderIcon";
import { FLIGHTS_SENTENCES } from "./constants";

export default function PostbookLoader() {
  const { t } = useTranslation();
  const sentences = useMemo(() => FLIGHTS_SENTENCES.map((key) => t(key)), [t]);

  return (
    <div className="h-100 flex w-full items-center justify-center">
      <div className="w-150 flex flex-col items-center justify-center p-4">
        <div>
          <PostBookLoaderIcon className="w-40 h-40"/>
        </div>
        <div>
          <TextSwapper sentences={sentences} className="text-background-primary font-medium"/>
        </div>
      </div>
    </div>
  );
}
